export default __webpack_public_path__ + "static/media/144.cf93f4ab.png";